import React, { useEffect, useRef, useState } from "react";
import { v4 } from 'uuid';
import { GdkToasts } from "@gdk/toasts";

/**
 * Use to set toast type - 'Confirmation' or 'Info'
 * @enum {string}
 * @deprecated - use the GDS Toast and ToastType
 */
export const ToastTypes = {
    Confirmation: "confirmation",
    Info: "update"
};

/**
 * Use to set toast float time - 'Short' for 6 second or 'Long' for 10 seconds
 * @enum {string}
 * @deprecated - use the GDS Toast and ToastType
 */
export const FloatTimes = {
    Short: "short",
    Long: "long"
};

export default function Toast({
    toastRef,
    header,
    description,
    toastType,
    floatTime,
    closeBtn,
    baseTimer,
    uuid = v4,
}) {
    const idRef = useRef(`toast-${uuid()}`);

    useEffect(() => {
        toastRef.current = new GdkToasts({
            content: `#${idRef.current}`,
            floatTime: floatTime,
            closeBtn: closeBtn,
            baseTimer: baseTimer,
        });
    }, []);

    return (
        <>
            <div id={idRef.current} className="toasts-container">
                <div className={`toasts toasts--${toastType}`}>
                    <div>
                        <span className={`icon-${toastType === "update" ? "info" : toastType}`} />
                    </div>
                    <div role="status">
                        {header &&
                            <div className="toasts--heading">{header}</div>
                        }
                        {description &&
                            <div className="toasts--content">{description}</div>
                        }
                    </div>
                    <button className="toasts--close-btn icon-close">
                        <div id="toasts--base-timer" />
                    </button>
                </div>
            </div>
        </>
    );
}
